import { WorkspaceEditModalForm } from './WorkspaceEditModalForm'

const WorkspaceEditModalFormWrapper = (props: any) => {
  return <WorkspaceEditModalForm modelHideshow={props.modelHideshow} fetchorganizationsList={props.fetchorganizationsList} />
}

export { WorkspaceEditModalFormWrapper }
